import { useState } from "react";
import {
  deleteEstadoCivil,
  getEstadoCivil,
  getEstadoCivilPaginated,
  postEstadoCivil
} from "../general_helpers/EstadoCivilData";
import { BasicFormIdDetalle } from "./BasicFormIdDetalle";
import { ListTablePaginated } from "./ListTablePaginated";

export const EstadoCivilList = () => {
  const columns = [
    { field: "id", headerName: "ID", flex: 0.3 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "nombre", headerName: "Nombre", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero
  ];
  const listName = "Estado Civil";

  const [estadoCivil, setEstadoCivil] = useState([]);
  const [createButton, setCreateButton] = useState(false);

  const options = {
    cols: columns,
    get: getEstadoCivil,
    getPaginated: getEstadoCivilPaginated,
    pageSize: [5, 10, 25],
    edit: true,
    listName,
    delete: deleteEstadoCivil,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,

    //DATOS PARA EL FORMULARIO
    createButton: createButton,
    setCreateButton: setCreateButton,
    setDataEdit: setEstadoCivil,
  };

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  if (createButton === false && estadoCivil.id !== undefined) {
    setEstadoCivil([]);
  }

  return (
    <>
      <BasicFormIdDetalle
        data={estadoCivil}
        createButton={createButton}
        listName={listName}
        setCreateButton={setCreateButton}
        componentList={"/generales/estado_civil/admin"}
        postData={postEstadoCivil}
      />
      <ListTablePaginated options={options} />
    </>
  );
};
